import { materialGroupReducer } from "../reducer/MaterialGroupReducer";

export const reducer = materialGroupReducer;